import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import List from "./components/List";
import Footer from "./components/Footer";
import Login from "./components/Login";
import Admin from "./components/Admin";
import ShowProduct from "./components/ShowProduct";
import AddProduct from "./components/AddProduct";
import Logo from "./Logo.png";
import { useUser } from "reactfire";
import firebaseConfig from "./firebase-config";
import firebase from "firebase/app";
import { ProductsContextProvider } from "./components/Context/AppContext";
import NavBar from "./components/Nav-Bar";
import "./App.css";
import ScannerCodeBar from "./components/ScannerCodeBar";

firebase.initializeApp(firebaseConfig);

function App() {
  const user = useUser();

  return (
    <Router>
      <ProductsContextProvider>
        <div className="App">
          <img className="logo" src={Logo} alt="logo" />
          {user && (
            <Switch>
              <Route component={AddProduct} path="/admin/products/:id" />
              <Route component={AddProduct} path="/admin/addProduct" />
            </Switch>
          )}
          <Switch>
            <Route component={ScannerCodeBar} path="/admin/scanner" />
            <Route exact path="/">
              <NavBar />
              {user && <Admin />}
              <List />
            </Route>
            <Route component={ShowProduct} path="/products/:id" />
            <Route exact path="/login">
              <Login />
            </Route>
          </Switch>
          <Footer />
        </div>
      </ProductsContextProvider>
    </Router>
  );
}

export default App;
